import { deserializeError, serializeError } from "@ledgerhq/errors";
import { BigNumber } from "bignumber.js";
import { mapValues } from "lodash";
import { getAccountUnit } from "../account";
import { formatCurrencyUnit } from "../currencies";
export const fromTransactionCommonRaw = (raw) => {
    const common = {
        amount: new BigNumber(raw.amount),
        recipient: raw.recipient,
    };
    if ("useAllAmount" in raw) {
        common.useAllAmount = raw.useAllAmount;
    }
    if ("subAccountId" in raw) {
        common.subAccountId = raw.subAccountId;
    }
    if ("recipientDomain" in raw) {
        common.recipientDomain = raw.recipientDomain;
    }
    return common;
};
export const toTransactionCommonRaw = (raw) => {
    const common = {
        amount: raw.amount.toString(),
        recipient: raw.recipient,
    };
    if ("useAllAmount" in raw) {
        common.useAllAmount = raw.useAllAmount;
    }
    if ("subAccountId" in raw) {
        common.subAccountId = raw.subAccountId;
    }
    if ("recipientDomain" in raw) {
        common.recipientDomain = raw.recipientDomain;
    }
    return common;
};
const fromErrorRaw = (raw) => {
    return deserializeError(JSON.parse(raw)) || new Error("unknown reason");
};
const toErrorRaw = (raw) => JSON.stringify(serializeError(raw)) || "{}";
export const fromTransactionStatusRawCommon = (ts) => ({
    errors: mapValues(ts.errors, fromErrorRaw),
    warnings: mapValues(ts.warnings, fromErrorRaw),
    estimatedFees: new BigNumber(ts.estimatedFees),
    amount: new BigNumber(ts.amount),
    totalSpent: new BigNumber(ts.totalSpent),
    recipientIsReadOnly: ts.recipientIsReadOnly,
});
export const toTransactionStatusRawCommon = (ts) => ({
    errors: mapValues(ts.errors, toErrorRaw),
    warnings: mapValues(ts.warnings, toErrorRaw),
    estimatedFees: ts.estimatedFees.toString(),
    amount: ts.amount.toString(),
    totalSpent: ts.totalSpent.toString(),
    recipientIsReadOnly: ts.recipientIsReadOnly,
});
const formatErrorSmall = (e) => (e.name === "Error" ? e.message : e.name);
export const formatTransactionStatusCommon = (t, { errors, warnings, estimatedFees, amount, totalSpent }, mainAccount) => {
    let str = "";
    const account = (t.subAccountId && (mainAccount.subAccounts || []).find(a => a.id === t.subAccountId)) ||
        mainAccount;
    str +=
        "\n  amount: " +
            formatCurrencyUnit(getAccountUnit(account), amount, {
                showCode: true,
                disableRounding: true,
            });
    str +=
        "\n  estimated fees: " +
            formatCurrencyUnit(getAccountUnit(mainAccount), estimatedFees, {
                showCode: true,
                disableRounding: true,
            });
    str +=
        "\n  total spent: " +
            formatCurrencyUnit(getAccountUnit(account), totalSpent, {
                showCode: true,
                disableRounding: true,
            });
    str +=
        "\n" +
            `errors: ${Object.entries(errors)
                .map(([key, error]) => `${key} ${formatErrorSmall(error)}`)
                .join(", ")}`;
    str +=
        "\n" +
            `errors: ${Object.entries(warnings)
                .map(([key, warning]) => `${key} ${formatErrorSmall(warning)}`)
                .join(", ")}`;
    return str;
};
//# sourceMappingURL=common.js.map